<div class="add-primary-account">
  <ng-container *ngIf="!invalidCancelledChequeUploaded">
    <div class="mb-1 fs-14 fw-semibold">
      Please enter the primary account details that correspond to the shared KYC documents.
    </div>
    <p class="text-sm text-secondary fw-medium">This account will be
      whitelisted and used for fund transfers to the virtual account.</p>
  </ng-container>
  <p class="text-danger"
    *ngIf="invalidCancelledChequeUploaded">We’ve marked the documents that need your attention. Please re-upload them
    to proceed
    with your KYC verification</p>
  <form [formGroup]="primaryAccountFormGroup"
    class="mt-2">
    <div class="mb-3">
      <label for="account_holder_name"
        class="col-form-label">Account Holder Name <span class="text-danger">*</span></label>
      <pmd-textfield pmd-textfield-outline>
        <input type="text"
          class="form-control"
          id="account_holder_name"
          placeholder="Enter Account Holder Name"
          formControlName="bankHolderName">
        <div *ngIf="sharedService.hasErrors(f.bankHolderName, isSubmitAttempted)"
          class="invalid-feedback d-block">
          <ng-container *ngIf="f.bankHolderName.errors.required">
            Account Holder Name is required
          </ng-container>
          <ng-container *ngIf="f.bankHolderName.errors.maxlength">
            Maximum 20 characters are allowed
          </ng-container>
        </div>
      </pmd-textfield>
    </div>
    <div class="mb-3">
      <label for="account_number"
        class="col-form-label">Account Number <span class="text-danger">*</span></label>
      <pmd-textfield pmd-textfield-outline>
        <input type="password"
          class="form-control"
          id="account_number"
          placeholder="Enter Account Number"
          formControlName="bankAccountNumber"
          (keypress)="sharedService.numberOnly($event)"
          appBlockCopyPaste>
        <div *ngIf="sharedService.hasErrors(f.bankAccountNumber, isSubmitAttempted)"
          class="invalid-feedback d-block">
          <ng-container *ngIf="f.bankAccountNumber.errors.required">
            Account Number is required
          </ng-container>
          <ng-container *ngIf="f.bankAccountNumber.errors.maxlength">
            Maximum 17 digits are allowed
          </ng-container>
        </div>
      </pmd-textfield>
    </div>
    <div class="mb-3">
      <label for="reaccount_number"
        class="col-form-label">Re-enter Account Number <span class="text-danger">*</span></label>
      <pmd-textfield pmd-textfield-outline>
        <input type="text"
          class="form-control"
          id="reaccount_number"
          placeholder="Please Re-enter Account Number"
          formControlName="confirmBankAccountNumber"
          (keypress)="sharedService.numberOnly($event)"
          appBlockCopyPaste>
        <div *ngIf="sharedService.hasErrors(f.confirmBankAccountNumber, isSubmitAttempted)"
          class="invalid-feedback d-block">
          <ng-container *ngIf="f.confirmBankAccountNumber.errors.required">
            Please re-enter Account Number
          </ng-container>
          <ng-container *ngIf="f.confirmBankAccountNumber.errors.maxlength">
            Maximum 17 digits are allowed
          </ng-container>
          <ng-container *ngIf="f.confirmBankAccountNumber.errors.confirmValidation">
            Confirm bank account number does not match
          </ng-container>
        </div>
      </pmd-textfield>
    </div>
    <div class="mb-3">
      <label for="ifsccode"
        class="col-form-label">IFSC Code <span class="text-danger">*</span></label>
      <pmd-textfield pmd-textfield-outline>
        <input type="text"
          class="form-control"
          id="ifsccode"
          appUppercase
          placeholder="Enter IFSC Code"
          formControlName="ifscCode">
        <div *ngIf="sharedService.hasErrors(f.ifscCode, isSubmitAttempted)"
          class="invalid-feedback d-block">
          <ng-container *ngIf="f.ifscCode.errors.required">
            IFSC Code is required
          </ng-container>
          <ng-container *ngIf="f.ifscCode.errors.pattern">
            Please enter valid IFSC Code
          </ng-container>
        </div>
      </pmd-textfield>
    </div>
    <div class="mb-3">
      <label for="mobilenum"
        class="col-form-label">Mobile Number <span class="text-danger">*</span></label>
      <pmd-textfield pmd-textfield-outline>
        <input type="text"
          class="form-control"
          id="mobilenum"
          placeholder="Enter Mobile Number"
          formControlName="mobile"
          (keypress)="sharedService.numberOnly($event)">
        <div *ngIf="sharedService.hasErrors(f.mobile, isSubmitAttempted)"
          class="invalid-feedback d-block">
          <ng-container *ngIf="f.mobile.errors.required">
            Mobile Number is required
          </ng-container>
          <ng-container *ngIf="f.mobile.errors.pattern">
            Please enter valid mobile number
          </ng-container>
        </div>
      </pmd-textfield>
    </div>
    <div class="mb-3">
      <label for="enmail"
        class="col-form-label">E-mail ID <span class="text-danger">*</span></label>
      <pmd-textfield pmd-textfield-outline>
        <input type="email"
          class="form-control"
          id="enmail"
          placeholder="Enter E-mail ID"
          formControlName="email">
        <div *ngIf="sharedService.hasErrors(f.email, isSubmitAttempted)"
          class="invalid-feedback d-block">
          <ng-container *ngIf="f.email.errors.required">
            Email is required
          </ng-container>
          <ng-container *ngIf="f.email.errors.pattern">
            Please enter valid email id
          </ng-container>
        </div>
      </pmd-textfield>
    </div>
    <div class="row">
      <div class="col-md-12 col-xl-7">
        <div class="upload-block">
          <!-- <ng-container *ngIf="!cancelledChequeFile">
            <div class="pmd-drop-container border"
              ngFileDrop>
              <input type="file"
                ngFileSelect
                class="pmd-upload-button"
                (change)="onUploadOutput($event.target.files)" />
              <div class="khr-upload-no-data">
                <i class="pmd-icon-circle pmd-icon-secondary pmd-icon-md flex-shrink-0 mb-3">
                  <svg xmlns="http://www.w3.org/2000/svg"
                    width="26.934"
                    height="23.401"
                    viewBox="0 0 26.934 23.401">
                    <g id="upload"
                      transform="translate(0 -0.999)">
                      <path id="Path_306"
                        data-name="Path 306"
                        d="M.842,9.9a.842.842,0,0,1,.842.842V14.95a1.683,1.683,0,0,0,1.683,1.683h20.2a1.683,1.683,0,0,0,1.683-1.683V10.742a.842.842,0,1,1,1.683,0V14.95a3.367,3.367,0,0,1-3.367,3.367H3.367A3.367,3.367,0,0,1,0,14.95V10.742A.842.842,0,0,1,.842,9.9Z"
                        transform="translate(0 6.083)"
                        fill="#EBB901" />
                      <path id="Path_307"
                        data-name="Path 307"
                        d="M9.8,1.246a.842.842,0,0,1,1.192,0l5.05,5.05a.843.843,0,1,1-1.192,1.192L11.234,3.874v14.8a.842.842,0,0,1-1.683,0V3.874L5.938,7.488A.843.843,0,0,1,4.746,6.3L9.8,1.246Z"
                        transform="translate(3.075 0)"
                        fill="#EBB901" />
                    </g>
                  </svg>
                </i>
                <h6 class="mb-2 text-dark fw-normal text-sm">Drag and Drop file(s) or
                  <label class="text-secondary fw-semibold">Browse Files</label>
                </h6>
                <p class="text-desc">Max 10 MB files are allowed</p>
              </div>
            </div>
            <p class="text-lighter mt-2">Only .jpg, .png and .pdf files are supported</p>
          </ng-container> -->
          <!-- <div class="selected-upload-file border rounded-3 px-3 py-2"
            *ngIf="cancelledChequeFile"> -->
          <!-- <div class="row justify-content-between">
              <div class="col-6 col-md-8">
                <div class="d-flex align-items-center text-desc">
                  <img src="assets/images/jpg_folder.svg"
                    alt="">
                  <span class="ms-2 text-truncate">{{cancelledChequeFile.name}}</span>
                </div>
              </div> -->
          <!-- <div class="col-auto text-desc d-flex align-items-center">
                <span>{{cancelledChequeFile.size | filesize}}</span><span
                  class="material-symbols-outlined text-danger align-bottom cursor-pointer"
                  (click)="onCancelledChequeDelete()">
                  delete
                </span>
              </div>
            </div>
            <div *ngIf="fileUploadLoader">
              <p>Uploading document, Please wait</p>
            </div> -->
          <!-- </div> -->
          <!-- <div *ngIf="cancelledChequeResponse" class="d-flex align-items-center gap-1 mt-1">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.8654 5.52533L11.8014 6.47533L7.93936 10.28C7.68136 10.538 7.34203 10.6667 7.00136 10.6667C6.6607 10.6667 6.31803 10.5367 6.05736 10.2767L4.2027 8.47933L5.13136 7.52133L6.99336 9.326L10.8654 5.52533ZM16 8C16 12.4113 12.4114 16 8.00003 16C3.5887 16 3.05176e-05 12.4113 3.05176e-05 8C3.05176e-05 3.58867 3.5887 0 8.00003 0C12.4114 0 16 3.58867 16 8ZM14.6667 8C14.6667 4.324 11.676 1.33333 8.00003 1.33333C4.32403 1.33333 1.33336 4.324 1.33336 8C1.33336 11.676 4.32403 14.6667 8.00003 14.6667C11.676 14.6667 14.6667 11.676 14.6667 8Z"
                fill="#039855" />
            </svg> <span class="text-success">Document uploaded</span>
          </div> -->
        </div>
      </div>
    </div>
    <div class="mb-4">
      <p class="mb-2">
        <span class="fw-semibold">Cancelled Cheque</span>
        <span class="text-desc"> (On legal name only)</span>
        <span class="text-danger">*</span>
      </p>
      <div class="position-relative file-input-control">
        <pmd-input-group-filled class="mb-2 cursor-pointer"
          [ngClass]="{'border border-danger rounded-3 overflow-hidden': primaryAccountCancelledChequeName?.verificationDescription}">
          <pmd-input-group-text>
            <label class="text-secondary text-sm fw-medium"
              for="{{cancelledChequeFile || primaryAccountCancelledChequeName ? null : 'customFile02'}}"
              (click)="previewImage()">
              {{cancelledChequeFile || primaryAccountCancelledChequeName ? 'View' : 'Choose File'}} </label>
          </pmd-input-group-text>
          <input [type]="primaryAccountCancelledChequeName ? 'text': 'file'"
            formControlName="primaryAccountCancelledCheque"
            ngFileSelect
            (change)="onUploadOutput($event.target.files)"
            class="form-control file-upload-control"
            placeholder="Choose File To Upload"
            id="customFile02"
            readonly
            [value]="primaryAccountCancelledChequeName ? primaryAccountCancelledChequeName?.name :  null"
            [ngClass]="{'value-selected': primaryAccountCancelledChequeName?.name}"
            #fileInput>
          <div class="icon-delete"
            *ngIf="primaryAccountFormGroup.get('primaryAccountCancelledCheque').value"
            (click)="removeFile(primaryAccountFormGroup.get('primaryAccountCancelledCheque').value, fileInput)">
            <svg width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8.4375 4.0625V4.375H11.5625V4.0625C11.5625 3.6481 11.3979 3.25067 11.1049 2.95765C10.8118 2.66462 10.4144 2.5 10 2.5C9.5856 2.5 9.18817 2.66462 8.89515 2.95765C8.60212 3.25067 8.4375 3.6481 8.4375 4.0625ZM7.1875 4.375V4.0625C7.1875 3.31658 7.48382 2.60121 8.01126 2.07376C8.53871 1.54632 9.25408 1.25 10 1.25C10.7459 1.25 11.4613 1.54632 11.9887 2.07376C12.5162 2.60121 12.8125 3.31658 12.8125 4.0625V4.375H17.5C17.6658 4.375 17.8247 4.44085 17.9419 4.55806C18.0592 4.67527 18.125 4.83424 18.125 5C18.125 5.16576 18.0592 5.32473 17.9419 5.44194C17.8247 5.55915 17.6658 5.625 17.5 5.625H16.5575L15.375 15.98C15.2878 16.7426 14.923 17.4465 14.3501 17.9573C13.7772 18.4682 13.0363 18.7504 12.2687 18.75H7.73125C6.96366 18.7504 6.22279 18.4682 5.64991 17.9573C5.07702 17.4465 4.7122 16.7426 4.625 15.98L3.4425 5.625H2.5C2.33424 5.625 2.17527 5.55915 2.05806 5.44194C1.94085 5.32473 1.875 5.16576 1.875 5C1.875 4.83424 1.94085 4.67527 2.05806 4.55806C2.17527 4.44085 2.33424 4.375 2.5 4.375H7.1875ZM5.8675 15.8375C5.91968 16.2949 6.13835 16.7172 6.48183 17.0238C6.82531 17.3304 7.26959 17.4999 7.73 17.5H12.2694C12.7298 17.4999 13.1741 17.3304 13.5175 17.0238C13.861 16.7172 14.0797 16.2949 14.1319 15.8375L15.3 5.625H4.70062L5.8675 15.8375ZM8.125 7.8125C8.29076 7.8125 8.44973 7.87835 8.56694 7.99556C8.68415 8.11277 8.75 8.27174 8.75 8.4375V14.6875C8.75 14.8533 8.68415 15.0122 8.56694 15.1294C8.44973 15.2467 8.29076 15.3125 8.125 15.3125C7.95924 15.3125 7.80027 15.2467 7.68306 15.1294C7.56585 15.0122 7.5 14.8533 7.5 14.6875V8.4375C7.5 8.27174 7.56585 8.11277 7.68306 7.99556C7.80027 7.87835 7.95924 7.8125 8.125 7.8125ZM12.5 8.4375C12.5 8.27174 12.4342 8.11277 12.3169 7.99556C12.1997 7.87835 12.0408 7.8125 11.875 7.8125C11.7092 7.8125 11.5503 7.87835 11.4331 7.99556C11.3158 8.11277 11.25 8.27174 11.25 8.4375V14.6875C11.25 14.8533 11.3158 15.0122 11.4331 15.1294C11.5503 15.2467 11.7092 15.3125 11.875 15.3125C12.0408 15.3125 12.1997 15.2467 12.3169 15.1294C12.4342 15.0122 12.5 14.8533 12.5 14.6875V8.4375Z"
                fill="#212121" />
            </svg>
          </div>
        </pmd-input-group-filled>
        <p class="text-danger fw-medium text-xs"
          *ngIf="primaryAccountCancelledChequeName?.verificationDescription">
          <span>{{primaryAccountCancelledChequeName?.verificationDescription ?? ''}}</span>
        </p>
      </div>
    </div>
  </form>
</div>

<div pmdModal
  #document_uploaded="pmd-modal"
  class="modal pmd-modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="vertically-centered">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <!-- Modal Body -->
      <div class="modal-body">
        <div class="d-flex align-items-center flex-column">
          <img src="assets/images/document-uploaded.gif"
            alt="document-uploaded.gif"
            class="w-25">
          <p class="fs-6 text-dark fw-semibold">Documents sent for KYC Verification
          </p>
        </div>
      </div>
    </div>
  </div>
</div>


<div pmdModal
  #cancelledChequeImagePreviewModal="pmd-modal"
  class="modal pmd-modal fade"
  tabindex="-1"
  role="dialog"
  (onShow)="previewCancelledChequeImage;"
  aria-labelledby="vertically-centered">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <app-zoom [path]="previewCancelledChequeImage"
        [showCloseIcon]="true"
        [isFullScreen]="false"
        class="me-2 w-100"
        (closeEvent)="cancelledChequeImagePreviewModal.hide()">
      </app-zoom>
    </div>
  </div>
</div>

<div pmdModal
  #cancelledChequePdfPreviewModal="pmd-modal"
  class="modal pmd-modal fade"
  tabindex="-1"
  role="dialog"
  (onShow)="previewCancelledChequePDF;"
  aria-labelledby="vertically-centered">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <app-pdf-zoom [path]="previewCancelledChequePDF"
        [showCloseIcon]="true"
        (closeEvent)="cancelledChequePdfPreviewModal.hide()"
        [isFullScreen]="false"
        [zoomScale]="'page-height'"
        class="me-2 w-100">
      </app-pdf-zoom>
    </div>
  </div>
</div>